/* Five to Thrive landing section behavior.
   Config arrives from the section as a JSON script tag. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.f2tInit === '1') return;
    root.dataset.f2tInit = '1';

    var cfgEl = root.querySelector('[data-f2t-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var PRICES = { teacher: cfg.teacherPrice || 0, leader: cfg.leaderPrice || 0 };
    var IDS = { teacher: cfg.teacherId, leader: cfg.leaderId };
    var NAMES = cfg.names || {};
    var LABELS = cfg.labels || {};
    var SITE_LABEL = cfg.siteLabel || '';

    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD' });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    function money(cents) { return fmt.format(cents / 100); }

    var state = { version: 'teacher', qty: 1 };

    var variantInput = root.querySelector('[data-f2t-variant-input]');
    var qtySelect = root.querySelector('[data-f2t-qty]');
    var purchaseWrap = root.querySelector('[data-f2t-purchase]');
    var quoteWrap = root.querySelector('[data-f2t-quote]');
    var barLabel = root.querySelector('[data-f2t-bar-label]');
    var barCta = root.querySelector('[data-f2t-bar-cta]');

    function each(sel, fn) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), fn);
    }

    function render() {
      var isQuote = state.version === 'site';

      each('[data-f2t-version]', function (el) {
        var on = el.getAttribute('data-f2t-version') === state.version;
        el.setAttribute('data-selected', on ? 'true' : 'false');
        var input = el.querySelector('input');
        if (input) input.checked = on;
      });

      if (purchaseWrap) purchaseWrap.hidden = isQuote;
      if (quoteWrap) quoteWrap.hidden = !isQuote;

      var totalText = isQuote ? SITE_LABEL : money(PRICES[state.version] * state.qty);
      each('[data-f2t-total]', function (el) { el.textContent = totalText; });

      if (variantInput && !isQuote) variantInput.value = IDS[state.version];

      if (barLabel) {
        barLabel.textContent = isQuote
          ? (NAMES.site || '')
          : (NAMES[state.version] || '') + ' × ' + state.qty;
      }
      if (barCta) barCta.textContent = isQuote ? LABELS.requestQuote : LABELS.addToCart;
    }

    function scrollToQuote() {
      var el = root.querySelector('[data-f2t-quote-anchor]');
      if (!el) return;
      var top = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 20;
      try {
        window.scrollTo({ top: top, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, top);
      }
    }

    /* ---- version radios ---- */
    each('[data-f2t-version]', function (el) {
      el.addEventListener('change', function () {
        state.version = el.getAttribute('data-f2t-version');
        render();
        syncIncludedTabs();
      });
    });

    if (qtySelect) {
      qtySelect.addEventListener('change', function () {
        state.qty = parseInt(qtySelect.value, 10) || 1;
        render();
      });
    }

    /* ---- sticky bar ---- */
    if (barCta) {
      barCta.addEventListener('click', function () {
        if (state.version === 'site') { scrollToQuote(); return; }
        var form = root.querySelector('.f2t__form');
        if (!form) return;
        var submit = form.querySelector('[type="submit"]');
        if (submit) { submit.click(); } else { form.submit(); }
      });
    }

    var quoteLink = root.querySelector('[data-f2t-quote-link]');
    if (quoteLink) {
      quoteLink.addEventListener('click', function (e) { e.preventDefault(); scrollToQuote(); });
    }

    /* ---- What's included: teacher / leader tabs (shares version state) ---- */
    function applyIncluded(aud) {
      each('[data-f2t-inc]', function (card) {
        var a = card.getAttribute('data-f2t-inc');
        card.hidden = !(a === 'both' || a === aud);
      });
      each('[data-f2t-tab]', function (btn) {
        btn.setAttribute('aria-selected', btn.getAttribute('data-f2t-tab') === aud ? 'true' : 'false');
      });
    }
    function syncIncludedTabs() {
      applyIncluded(state.version === 'leader' ? 'leader' : 'teacher');
    }
    each('[data-f2t-tab]', function (btn) {
      btn.addEventListener('click', function () {
        state.version = btn.getAttribute('data-f2t-tab');
        render();
        applyIncluded(state.version);
      });
    });
    syncIncludedTabs();

    /* ---- FAQ accordion: one open at a time ---- */
    var faqWrap = root.querySelector('[data-f2t-faqs]');
    if (faqWrap) {
      faqWrap.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-f2t-faq-q]') : null;
        if (!btn || !faqWrap.contains(btn)) return;
        var wasOpen = btn.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(faqWrap.querySelectorAll('[data-f2t-faq-q]'), function (b) {
          b.setAttribute('aria-expanded', 'false');
          var s = b.querySelector('.f2t__faq-sign');
          if (s) s.textContent = '+';
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
        });
        if (!wasOpen) {
          btn.setAttribute('aria-expanded', 'true');
          var sign = btn.querySelector('.f2t__faq-sign');
          if (sign) sign.textContent = '−';
          var p = document.getElementById(btn.getAttribute('aria-controls'));
          if (p) p.hidden = false;
        }
      });
    }

    /* ---- Countdown ---- */
    var cdWrap = root.querySelector('[data-f2t-countdown]');
    if (cdWrap && cfg.countdownTarget) {
      var target = new Date(cfg.countdownTarget).getTime();
      if (!isNaN(target)) {
        cdWrap.hidden = false;
        var cells = {
          days: cdWrap.querySelector('[data-cd="days"]'),
          hours: cdWrap.querySelector('[data-cd="hours"]'),
          mins: cdWrap.querySelector('[data-cd="mins"]'),
          secs: cdWrap.querySelector('[data-cd="secs"]')
        };
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var timer = null;
        var tick = function () {
          var diff = target - Date.now();
          if (diff <= 0) {
            if (cfg.countdownEnded === 'swap') {
              var units = cdWrap.querySelector('[data-f2t-cd-units]');
              if (units) units.style.display = 'none';
              var note = cdWrap.querySelector('[data-f2t-cd-note]');
              if (note) note.textContent = cfg.countdownEndedText || '';
            } else {
              cdWrap.hidden = true;
            }
            if (timer) clearInterval(timer);
            return;
          }
          if (cells.days) cells.days.textContent = String(Math.floor(diff / 86400000));
          if (cells.hours) cells.hours.textContent = pad(Math.floor(diff / 3600000) % 24);
          if (cells.mins) cells.mins.textContent = pad(Math.floor(diff / 60000) % 60);
          if (cells.secs) cells.secs.textContent = pad(Math.floor(diff / 1000) % 60);
        };
        tick();
        timer = setInterval(tick, 1000);
      }
    }

    /* ---- HubSpot embed ---- */
    if (cfg.hubspotFormId) {
      (function mountHubspot(tries) {
        var t = tries || 0;
        var target = root.querySelector('[data-f2t-hs]');
        if (!target) return;
        if (window.hbspt && window.hbspt.forms) {
          if (target.getAttribute('data-hs-mounted')) return;
          target.setAttribute('data-hs-mounted', '1');
          window.hbspt.forms.create({
            portalId: cfg.hubspotPortalId,
            formId: cfg.hubspotFormId,
            region: cfg.hubspotRegion || 'na1',
            target: '#' + target.id
          });
          return;
        }
        if (t < 40) setTimeout(function () { mountHubspot(t + 1); }, 250);
      })(0);
    }

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-f2t]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-initialize when the theme editor reloads the section. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-f2t]') : null;
    if (el) { el.dataset.f2tInit = '0'; init(el); }
  });
})();
